import cmp from './AcceptedBids'

export default cmp
